require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./people-sian-teasdale.json") })
        }
      }, "path---people-sian-teasdale");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---people-sian-teasdale!./.cache/json/people-sian-teasdale.json
// module id = 1474
// module chunks = 231608221292675